import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  CircularProgress,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  Backdrop,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Box
} from '@material-ui/core';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { ClientListHead } from '../../_dashboard/clients';
import Controls from '../../controls/Controls';

const useStyles = makeStyles(() =>
  createStyles({
    tableFooter: {
      backgroundColor: '#1a1a1a',
      color: 'white'
    },
    tableHeaderCell: {
      color: 'white !important',
      fontWeight: 'bold',
      '& .MuiTableSortLabel-root': {
        color: 'white !important',
        '&:focus': {
          color: 'white !important'
        },
        '&:hover': {
          color: 'white !important'
        }
      },
      '& .MuiTableSortLabel-root.Mui-active': {
        color: 'white !important',
        '&:focus': {
          color: 'white !important'
        }
      },
      '&:hover': {
        backgroundColor: 'transparent !important'
      }
    }
  })
);
const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: '#f2f2f2' // Custom light gray instead of theme color
      },
      '&:hover': {
        backgroundColor: '#e0e0e0 !important' // Optional: custom hover effect
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'cifNumber', label: 'CIF Number', alignRight: false, width: 90 },
  { id: 'membershipNo', label: 'Membership No', alignRight: true, width: 110 },
  { id: 'firstName', label: 'First Name', alignRight: true, width: 90 },
  { id: 'surname', label: 'Surname', alignRight: true, width: 110 },
  { id: 'idNumber', label: 'ID Number', alignRight: true, width: 110 },
  { id: 'sexId', label: 'Gender ID', alignRight: true, width: 80 },
  { id: 'cellNumber', label: 'Cell Number', alignRight: true, width: 110 },
  { id: 'memberStatus', label: 'Member Status', alignRight: true, width: 110 }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_doc) =>
      Object.values(_doc).some(
        (val) => val && val.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  }

  return stabilizedThis.map((el) => el[0]);
}

export default function ActiveWithoutSpouse() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected] = useState([]);
  const [begDate, setBegDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [docType, setDocType] = useState('pdf');
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('cifNumber');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const classes = useStyles();
  const filename = `ActiveMembers_${moment().format('DD-MMM-YYYY')}.${docType}`;

  useEffect(() => {
    GetMovementStats();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const GetMovementStats = () => {
    setLoading(true);

    fetch(`${baseUrl}/api/Client/GetActiveMembersWithoutSpouse`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch data.');
        return res.json();
      })
      .then((result) => {
        const rawList = result.result || result || [];

        const mappedList = rawList.map((item) => ({
          cifNumber: item.cif_number,
          membershipNo: item.memberShipNo,
          firstName: item.firstName,
          surname: item.surname,
          idNumber: item.idNumber,
          sexId: item.sex_ID,
          cellNumber: item.cellNumber,
          memberStatus: item.memberStatus
        }));

        setDataList(mappedList);
        setLoading(false);
      })
      .catch((error) => {
        alert(`Error fetching active members: ${error.message}`);
        setLoading(false);
      });
  };

  const downloadDocument = () => {
    setLoading(true);
    const formattedBegDate = moment(begDate).format('MM-DD-YYYY');
    const formattedEndDate = moment(endDate).format('MM-DD-YYYY');

    fetch(
      `${baseUrl}/api/Report/Get/ActiveMembersWithoutSpouse/${docType}/${formattedBegDate}/${formattedEndDate}/0/0/0/0/0`
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoading(false);
      })
      .catch((error) => {
        alert(`Error downloading file: ${error}`);
        setLoading(false);
      });
  };

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;
  const isListEmpty = filteredUsers.length === 0;

  return (
    <Container>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{ mb: 2, overflowX: 'auto', flexWrap: 'nowrap' }}
      >
        {/* Label */}
        <Grid item sx={{ flexShrink: 0 }}>
          <Typography variant="h6" sx={{ whiteSpace: 'nowrap', fontSize: 16 }}>
            Active Members Without Spouse
          </Typography>
        </Grid>

        {/* Controls */}
        <Grid item sx={{ display: 'flex', gap: 1, flexWrap: 'nowrap', alignItems: 'center' }}>
          {/* Document Type Dropdown */}
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel id="selectDoc" sx={{ fontSize: 12 }}>
              Document Type
            </InputLabel>
            <Select
              size="small"
              value={docType}
              onChange={(e) => setDocType(e.target.value)}
              label="Document Type"
              sx={{ fontSize: 12 }}
            >
              <MenuItem value="pdf" sx={{ fontSize: 12 }}>
                PDF
              </MenuItem>
              <MenuItem value="xls" sx={{ fontSize: 12 }}>
                Excel
              </MenuItem>
              <MenuItem value="csv" sx={{ fontSize: 12 }}>
                CSV
              </MenuItem>
            </Select>
          </FormControl>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              inputFormat="dd/MM/yyyy"
              value={begDate}
              onChange={(date) => setBegDate(date)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  sx={{ minWidth: 120 }}
                  InputLabelProps={{ shrink: true }}
                  helperText="" // removes format hint
                />
              )}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End Date"
              inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={(date) => setEndDate(date)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  sx={{ minWidth: 120 }}
                  InputLabelProps={{ shrink: true }}
                  helperText="" // removes format hint
                />
              )}
            />
          </LocalizationProvider>

          {/* Download Button */}
          <Button
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={downloadDocument}
            size="small"
            sx={{ whiteSpace: 'nowrap', fontSize: 12, px: 2 }}
          >
            Download
          </Button>

          {/* Export CSV Button */}
          <CSVLink
            data={dataList}
            filename={filename.replace('.pdf', '.csv')}
            style={{ textDecoration: 'none' }}
          >
            <Button
              variant="outlined"
              size="small"
              sx={{ whiteSpace: 'nowrap', fontSize: 12, px: 2 }}
            >
              Export CSV
            </Button>
          </CSVLink>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, marginBottom: 10 }} />

      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 850 }}>
            <Table size="small">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                onRequestSort={handleRequestSort}
                classes={{ sortLabel: classes.tableHeaderCell }}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const {
                      cifNumber,
                      membershipNo,
                      firstName,
                      surname,
                      idNumber,
                      sexId,
                      cellNumber,
                      memberStatus
                    } = row;

                    const isItemSelected = selected.indexOf(cifNumber) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={cifNumber}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />

                        <TableCell align="left" style={{ width: 90 }}>
                          {cifNumber}
                        </TableCell>
                        <TableCell align="right" style={{ width: 110 }}>
                          {membershipNo}
                        </TableCell>
                        <TableCell align="right" style={{ width: 90 }}>
                          {firstName}
                        </TableCell>
                        <TableCell align="right" style={{ width: 110 }}>
                          {surname}
                        </TableCell>
                        <TableCell align="right" style={{ width: 110 }}>
                          {idNumber}
                        </TableCell>
                        <TableCell align="right" style={{ width: 80 }}>
                          {sexId}
                        </TableCell>
                        <TableCell align="right" style={{ width: 110 }}>
                          {cellNumber}
                        </TableCell>
                        <TableCell align="right" style={{ width: 110 }}>
                          {memberStatus}
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
              {isListEmpty && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={{ isOpen: false }} />
        </Scrollbar>
        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[10, 20, 30]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
